import { ref } from 'vue'
import { projectAuth } from '@/firebase/config'
import { updatePassword } from 'firebase/auth'

const error = ref(null)
const isPending = ref(false)

const login = async (email, password) => {
  error.value = null
  isPending.value = true

  try {
    const res = await projectAuth.signInWithEmailAndPassword(email, password)
    error.value = null
    isPending.value = false
    return res
  }
  catch(err) {
    console.log(err.message)
    error.value = 'Incorrect login credentials'
    isPending.value = false
  }
}

const sendPasswordResetEmail = async (email) => {
  error.value = null
  isPending.value = true

  try {
    const res = await projectAuth.sendPasswordResetEmail(email)
    error.value = null
    isPending.value = false
    return res
  }
  catch(err) {
    console.log(err.message)
    error.value = err.message
    isPending.value = false
  }
}

const doUpdatePassword = async (password) => {
  error.value = null
  isPending.value = true

  try {
    const res = await projectAuth.currentUser.updatePassword(password)
    error.value = null
    isPending.value = false
    return res
  }
  catch(err) {
    console.log(err.message)
    error.value = err.message
    isPending.value = false
  }
}

const useLogin = () => {
  return { error, login, sendPasswordResetEmail, doUpdatePassword, isPending }
}

export default useLogin